import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Button, Grid, Typography } from "@material-ui/core";
import SaveIcon from "@material-ui/icons/Save";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { validarSoloUnPermiso } from "../../../helpers/permisos";
import { useForm } from "../../../hooks/useForm";
import Select from "react-select";
import { useSelector, useDispatch } from "react-redux";
import { fetchAreas } from "../../../actions/usuarios/areas";
import { fetchRoles } from "../../../actions/usuarios/roles";
import { fetchCentrosMedicosPropios } from "../../../actions/centrosMedicosPropios";

const useStyles = makeStyles({
    botonera: {
        padding: 25
    }
});

export const FormReportesPorArea = (props) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { form, permisoEdit } = props
    const { items } = useSelector((state) => state.areas);
    const { items: roles } = useSelector((state) => state.roles);
    const { items: centros } = useSelector((state) => state.centrosMedicosPropios);
    const { permisos: permisosUser } = useSelector(state => state.auth);

    const [formValues,
        handleInputChange,
        ,
        setearValor] = useForm(form);

    const handleSave = (e) => {
        e.preventDefault()
        props.handleSave(formValues)
    }

    const HandleChangeAreas = (value) => {
        setearValor("reportesAreas", value.map(e => e.value))
    }

    const HandleChangeRoles = (value) => {
        setearValor("reportesRoles", value.map(e => e.value))
    }

    const HandleChangeCentros = (value) => {
        setearValor("reportesCentrosMedicos", value.map(e => e.value))
    }
    useEffect(() => {
        dispatch(fetchAreas());
        dispatch(fetchRoles());
        dispatch(fetchCentrosMedicosPropios())
    }, [dispatch]);

    return (
        <ValidatorForm onSubmit={handleSave}>
            <Grid container style={{ padding: 25 }}>
                <Grid item xs={12} md={6}>
                    <TextValidator
                        margin="normal"
                        label="Descripcion"
                        name="descripcionReporte"
                        value={formValues.descripcionReporte}
                        autoComplete="off"
                        onChange={handleInputChange}
                        fullWidth
                        style={{ paddingRight: "0.5rem" }}
                        validators={["required"]}
                        errorMessages={["Debe ingresar una descripcion."]}
                    />
                </Grid>
                <Grid item xs={12} md={10}>
                    <Typography variant="button">Areas</Typography>
                    <Select
                        onChange={HandleChangeAreas}
                        value={formValues.reportesAreas.map(reporteArea => ({
                            label: items.find(items => items.idArea === reporteArea)?.descripcion,
                            value: reporteArea
                        }))}
                        isMulti
                        name="colors"
                        options={items.map((item) => ({
                            value: item.idArea,
                            label: item.descripcion,
                        }))}
                        placeholder="Seleccione areas..."
                        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                        menuPosition="fixed"
                    />
                </Grid>
                <Grid item xs={12} md={10}>
                    <Typography variant="button">Roles</Typography>
                    <Select
                        onChange={HandleChangeRoles}
                        value={formValues.reportesRoles.map(reportesRoles => ({
                            label: roles.find(roles => roles.idRol === reportesRoles)?.descripcionRol,
                            value: reportesRoles
                        }))}
                        isMulti
                        name="colors"
                        options={roles.map((item) => ({
                            value: item.idRol,
                            label: item.descripcionRol,
                        }))}
                        placeholder="Seleccione roles..."
                        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                        menuPosition="fixed"
                    />
                </Grid>
                <Grid item xs={12} md={10}>
                    <Typography variant="button">Centros Medicos</Typography>
                    <Select
                        onChange={HandleChangeCentros}
                        value={formValues.reportesCentrosMedicos.map(reportesCentrosMedicos => ({
                            label: centros.find(centros => centros.idCentroMedico === reportesCentrosMedicos)?.descripcionCentro,
                            value: reportesCentrosMedicos
                        }))}
                        isMulti
                        name="colors"
                        options={centros.map((item) => ({
                            value: item.idCentroMedico,
                            label: item.descripcionCentro,
                        }))}
                        placeholder="Seleccione centros medicos..."
                        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                        menuPosition="fixed"
                    />
                </Grid>
            </Grid>
            <Grid container className={classes.botonera} >
                <Grid item xs={12}>
                    <Grid
                        container
                        spacing={1}
                        direction="row"
                        justify="flex-end"
                        alignItems="center"
                    >
                        {(validarSoloUnPermiso(permisosUser, permisoEdit)) &&

                            <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                startIcon={<SaveIcon />}
                                type='submit'
                                style={{ marginLeft: "0.5rem" }}
                            >
                                GUARDAR
                            </Button>
                        }
                    </Grid>
                </Grid>
            </Grid>
        </ValidatorForm >
    );

};

export default FormReportesPorArea;